"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DadosMaterialMI = void 0;
var DadosMaterialMI = /** @class */ (function () {
    function DadosMaterialMI(_a) {
        var _b = _a._id, _id = _b === void 0 ? '' : _b, _c = _a.material, material = _c === void 0 ? '' : _c, _d = _a.especie, especie = _d === void 0 ? '' : _d, _e = _a.grade, grade = _e === void 0 ? '' : _e, _f = _a.maxFls, maxFls = _f === void 0 ? 0 : _f, _g = _a.cumprimentoMaximo, cumprimentoMaximo = _g === void 0 ? 0 : _g, _h = _a.largura, largura = _h === void 0 ? 0 : _h, _j = _a.chave, chave = _j === void 0 ? '' : _j;
        this._id = _id;
        this.material = material;
        this.especie = especie;
        this.grade = grade;
        this.maxFls = maxFls;
        this.cumprimentoMaximo = cumprimentoMaximo;
        this.largura = largura;
        this.chave = chave;
    }
    return DadosMaterialMI;
}());
exports.DadosMaterialMI = DadosMaterialMI;
//# sourceMappingURL=DadosMaterialMI.js.map